import AnchorGuard from "./AnchorGuard";
export default AnchorGuard;